import React from 'react';
import { bool, func, object, number } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { shouldShowSelectPackage } from '../../../../utils/shouldShowSelectPackage';
import { isRecurringGig } from '../../../../reducers/packages';
import CtaBtn from './CtaBtn';
import CompareBtn from './CompareBtn';
import CheckoutPlans from './CheckoutPlans';

import './style.scss';

const TabFooter = ({
    showCompareAnchor = true,
    inProgress = false,
    currentPrice,
    isRecurringGig,
    onComparePackagesClick
}, { general, currencyConverter }) => {
    const showSelectPackage = shouldShowSelectPackage(general);
    const formattedPrice = currencyConverter.convert(currentPrice);

    if (!showSelectPackage && !showCompareAnchor && !isRecurringGig) {
        return null;
    }

    const wrapperClass = classNames(
        'tab-footer',
        { 'recurring-gig': isRecurringGig }
    );

    return (
        <footer className={wrapperClass}>
            {isRecurringGig && <CheckoutPlans/>}
            {showSelectPackage && <CtaBtn inProgress={inProgress} price={formattedPrice}/>}
            {showCompareAnchor && <CompareBtn onComparePackagesClick={onComparePackagesClick}/>}
        </footer>
    );
};

TabFooter.propTypes = {
    showCompareAnchor: bool,
    inProgress: bool,
    currentPrice: number,
    onComparePackagesClick: func
};

TabFooter.contextTypes = {
    general: object,
    currencyConverter: object
};

const mapStateToProps = ({ packages }) => ({
    isRecurringGig: isRecurringGig(packages)
});

export { TabFooter };
export default connect(mapStateToProps)(TabFooter);
